import { useState, useCallback, useMemo } from 'react';
var useConfirmation = function useConfirmation() {
  var _useState = useState(false),
    isVisible = _useState[0],
    setVisible = _useState[1];
  var setConfirmationVisible = useCallback(function () {
    return setVisible(true);
  });
  var setConfirmationHidden = useCallback(function () {
    return setVisible(false);
  });
  var _useMemo = useMemo(function () {
      var resolvePromise;
      var rejectPromise;
      var createPromise = function createPromise() {
        return new Promise(function (resolve, reject) {
          resolvePromise = resolve;
          rejectPromise = reject;
        });
      };
      return {
        awaitConfirmationResponse: function awaitConfirmationResponse() {
          setConfirmationVisible();
          return createPromise();
        },
        onConfirmCallback: function onConfirmCallback() {
          setConfirmationHidden();
          resolvePromise({
            isConfirmed: true
          });
        },
        onCancelCallback: function onCancelCallback() {
          setConfirmationHidden();
          rejectPromise({
            isConfirmed: false
          });
        }
      };
    }, []),
    awaitConfirmationResponse = _useMemo.awaitConfirmationResponse,
    onConfirmCallback = _useMemo.onConfirmCallback,
    onCancelCallback = _useMemo.onCancelCallback;
  return [isVisible, {
    setConfirmationVisible: setConfirmationVisible,
    setConfirmationHidden: setConfirmationHidden,
    asAwaitConfirmation: {
      awaitConfirmationResponse: awaitConfirmationResponse,
      onConfirmCallback: onConfirmCallback,
      onCancelCallback: onCancelCallback
    }
  }];
};
export default useConfirmation;